import React, { useState, useEffect } from "react";
import RhythmicPulseGrid from "./components/RhythmicPulseGrid";
import WaveInterferenceOptimized3 from "./components/asciiGrid";
import ShoreWaves from "./components/ShoreWaves";
import "./App.css";

function App() {
  const [hoverState, setHoverState] = useState({
    active: false,
    type: null,
    image: null,
  });

  // Preload all images on component mount for smooth hover transitions
  useEffect(() => {
    const imagesToPreload = [
      "/josh_le.JPG",
      "/cat_dad.jpeg",
      "/latte_artist.jpeg",
      "/new_york.jpeg",
      "/san_francisco.jpeg",
    ];

    imagesToPreload.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
      img.onload = () => {
        console.log(`Preloaded image: ${imageSrc}`);
      };
      img.onerror = () => {
        console.error(`Failed to preload image: ${imageSrc}`);
      };
    });
  }, []);

  const handleHover = (type, image) => {
    console.log("Hover started:", type, image);
    setHoverState({
      active: true,
      type: type,
      image: image,
    });
  };

  const handleHoverEnd = () => {
    console.log("Hover ended");
    setHoverState({
      active: false,
      type: null,
      image: null,
    });
  };

  return (
    <div className="app">
      <div className="main-content">
        <div className="content-container">
          <div className="animation-container">
            <ShoreWaves hoverState={hoverState} />
          </div>
          <div className="text-container">
            <div className="text-content">
              <p className="name">
                <span
                  className="hoverable-text"
                  onMouseEnter={() => handleHover("joshua-le", "/josh_le.JPG")}
                  onMouseLeave={handleHoverEnd}
                >
                  Joshua Le
                </span>
              </p>

              <p className="main-text">
                engineer, technical writer,{" "}
                <span
                  className="hoverable-text"
                  onMouseEnter={() => handleHover("cat-dad", "/cat_dad.jpeg")}
                  onMouseLeave={handleHoverEnd}
                >
                  cat dad
                </span>
                , and{" "}
                <span
                  className="hoverable-text"
                  onMouseEnter={() =>
                    handleHover("latte-artist", "/latte_artist.jpeg")
                  }
                  onMouseLeave={handleHoverEnd}
                >
                  latte artist
                </span>
              </p>

              <p className="main-text">
                currently based in{" "}
                <span
                  className="hoverable-text"
                  onMouseEnter={() =>
                    handleHover("san-francisco", "/san_francisco.jpeg")
                  }
                  onMouseLeave={handleHoverEnd}
                >
                  sf
                </span>
              </p>

              <p className="main-text">
                <a
                  href="https://hue.run"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  verifying
                </a>{" "}
                the world's work
              </p>

              <p className="main-text section-break">
                i've worked on products at{" "}
                <a
                  href="https://august.law"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  August
                </a>
                ,{" "}
                <a
                  href="https://gusto.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Gusto
                </a>
                ,{" "}
                <a
                  href="https://apple.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Apple
                </a>
                ,{" "}
                <a
                  href="https://wayfair.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Wayfair
                </a>
                ,{" "}
                <a
                  href="https://sixtyfour.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Sixtyfour
                </a>{" "}
                (YCS25), and{" "}
                <a
                  href="https://sendblue.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  SendBlue
                </a>{" "}
                (YC23)
              </p>

              <p className="main-text section-break">
                writings:{" "}
                <a
                  href="https://engineering.gusto.com/bee-ing-in-sync-centralizing-user-data-with-a-cdp-f66227fd2823"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Centralizing User Data with a Customer Data Platform
                </a>
                ,{" "}
                <a
                  href="https://engineering.gusto.com/the-interns-playbook-key-steps-to-a-successful-software-engineering-internship-41b9c95eb892"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  The Intern's Playbook
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer">
        <a
          href="https://www.linkedin.com/in/joshua-d-le/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          LinkedIn
        </a>
        <a
          href="https://github.com/joshle298"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          GitHub
        </a>
        <a href="mailto:josh@hue.run" className="footer-link">
          Email
        </a>
      </footer>
    </div>
  );
}

export default App;
